import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import _ from 'lodash';
import nl2br from 'react-nl2br';

import './news.less';
import {connect} from "react-redux";
import {getNews, getNewsItem} from "store/reducers/news";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import renderHTML from 'react-render-html';
import NewsSidebarComponent from "components/modules/news/sidebar";

@connect((state) => ({}), {getNewsItem})

export default class NewsFullComponent extends Component {

    state = {
        loading: false,
        news: {},
        uuid: null,
    };

    months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];

    async componentWillUpdate(props) {
        if (props.params.uuid !== this.state.uuid) {
            await this.setState({
                uuid: props.params.uuid,
            });
            this.loadNews();
        }
    }

    async componentDidMount() {
        await this.setState({
            uuid: this.props.params.uuid,
        });

        this.loadNews();
    }

    async loadNews() {
        this.setState({loading: true});
        const response = await this.props.getNewsItem(this.state.uuid);
        this.setState({loading: false});
        if (response.isOk) {
            const news = response.payload;
            this.setState({news});
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <Page pageId="News"
                  title="Новости">
                <div className="page-content">
                    <div className="page-block">
                        {loader}
                        {!loader ? this.renderNews() : null}
                    </div>
                    <NewsSidebarComponent {...this.props}/>
                </div>
            </Page>
        );
    }

    formatTimestamp(timestamp) {
        return (
            <span>
                {moment(timestamp).format('D')} {this.months[moment(timestamp).format('MM') - 1]} {moment(timestamp).format('YYYY')} г.
            </span>
        );
    }

    renderNews() {
        const {title, text, timestamp, source, image} = this.state.news;

        return (
            <div className="one-news">
                <div className="one-news__title">{title}</div>
                <div className="one-news__date">Опубликовано: {this.formatTimestamp(timestamp)}</div>
                {image ? <div className="one-news__img" style={{backgroundImage: `url(${image})`}}/> : null}
                <div className="one-news__source">Источник: {source}</div>
                <div className="one-news__text" dangerouslySetInnerHTML={{__html: `<div>${text}</div>`}}>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/modules/news/full.js